import type { ParticipantStatus } from "@/modules/profile/subscriber/subscriberTypes"

// Attention la clé slots et aussi utiliser dans le BoxPlanning
export const boxSlotKeys = {
  all: ["boxSlot"] as const,
  slot: (id: string) => [...boxSlotKeys.all, "details", id] as const,
  subscribers: (
    slotId: string,
    participantStatus: ParticipantStatus,
    filters?: {
      name?: string
      page?: number
      pageSize?: number
    },
  ) =>
    filters
      ? ([...boxSlotKeys.all, "subscribers", slotId, participantStatus, filters] as const)
      : ([...boxSlotKeys.all, "subscribers"] as const),
  nonParticipants: (
    slotId: string,
    filters?: {
      name?: string
    },
  ) =>
    filters
      ? ([...boxSlotKeys.all, "nonParticipants", slotId, filters] as const)
      : ([...boxSlotKeys.all, "nonParticipants", slotId] as const),
}
